import { lazy, Suspense, useMemo, memo } from 'react';

export const LazyWrapper = ({ importFn, fallback = <></> }) => {
  const WrappedLazy = memo<any>(({ children, ...props }) => {
    const LazyComp = useMemo(() => lazy(importFn), []);
    return (
      <Suspense fallback={fallback}>
        <LazyComp {...props}>{children}</LazyComp>
      </Suspense>
    );
  });
  return WrappedLazy;
};
